import { render } from "./ProductSetDeliveryExpressTemplate.vue?vue&type=template&id=8480b654"
import script from "./ProductSetDeliveryExpressTemplate.vue?vue&type=script&lang=js"
export * from "./ProductSetDeliveryExpressTemplate.vue?vue&type=script&lang=js"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__